var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "p",
      {
        staticClass: "mb-0",
      },
      [
        _vm.item_transactionable.match(/Ticket/g) && _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "red",
                  small: "",
                  outlined: "",
                },
              },
              [_vm._v("\n      ใช้คะแนน\n    ")]
            )
          : _vm.item_transactionable.match(/Ticket$/g) &&
            _vm.item_type == "debit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "green",
                  small: "",
                  outlined: "",
                },
              },
              [_vm._v("\n      รับคะแนน\n    ")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.item_remark
      ? _c(
          "p",
          {
            staticClass: "mb-0 d-inline-block",
            staticStyle: {
              "font-size": "0.8em",
              "max-width": "230px",
              "word-wrap": "break-word",
            },
            attrs: {
              title: _vm.item_remark,
            },
          },
          [_vm._v("\n    " + _vm._s(_vm.item_remark) + "\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }